import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/lib/queryKeys';
import {
  lossRecordService,
  type CreateLossRecordInput,
  type CompleteLossRecordInput,
} from '@/services/lossRecordService';

export const useCreateLossRecord = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: CreateLossRecordInput) => lossRecordService.create(input),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.lossRecord.all,
      });
    },
  });
};

export const useCompleteLossRecord = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: CompleteLossRecordInput) => lossRecordService.complete(input),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.lossRecord.all,
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.lossRecord.detail(variables.id),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.transactions.all,
      });
    },
  });
};
